/**
 * Scene manager - handles the Three.js scene setup
 */

import * as THREE from 'three';

export class SceneManager {
  public readonly scene: THREE.Scene;

  constructor() {
    this.scene = new THREE.Scene();
    // Use deep water color for fog and background so edges blend with ocean
    this.scene.fog = new THREE.Fog(0x1a5276, 80, 300);
    this.scene.background = new THREE.Color(0x1a5276);
  }

  add(object: THREE.Object3D): void {
    this.scene.add(object);
  }

  remove(object: THREE.Object3D): void {
    this.scene.remove(object);
  }

  clear(): void {
    while (this.scene.children.length > 0) {
      const child = this.scene.children[0];
      this.scene.remove(child);
    }
  }
}
